// features/usuarios/api/usuarios.api.js
// Capa de API para gestión de usuarios.
// Reemplaza gradualmente: usuario.resource.js + profile.resource.js
//
// Endpoints mapeados desde BaseService + UsuarioResource:
//   GET    /profile/users              → getAll
//   GET    /invitations                → getInvitations
//   POST   /profile/users             → create
//   PUT    /profile/users/:id          → update
//   DELETE /profile/users/:id          → remove
//   PUT    /user/me                    → updateMe
//   PUT    /me/password                → changePassword  (ruta base /api)
//   GET    /profile/users/names        → getNames

import { api } from '../../../api/client';

export const invitationsApi = {
  /** Lista todos los usuarios del sistema */
  

  search: (dataSearch) => api.post('/invitations/search', dataSearch),
 
};
